import e from "./highrise1425.mjs";
import o from "./highrise1332.mjs";
import r from "./highrise1333.mjs";
var a = r && r.isTypedArray, s = a ? o(a) : e;
export {
  s as default
};
